import * as routeActions from 'actions/routeActions'
import * as userActions from 'actions/userActions'

import { compose, withHandlers, withStateHandlers } from 'recompose'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import idx from 'idx'

export default compose(
  connect(
    (state) => {
      return {
        pathname: idx(state, _ => _.router.location.pathname) || '',
        hasError: idx(state, _ => _.progress.resetRequest.hasError) || false,
        errorMessage: idx(state, _ => _.progress.resetRequest.error.message) || null,
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      resetSuccess: false,
    }),
    {
      setResetSuccess: state => (value) => {
        return {
          ...state,
          resetSuccess: value
        }
      }
    }
  ),
  withHandlers({
    onReset: ({ actions, setResetSuccess }) => (email) => {
      actions.resetPasswordRequest(email, () => {
        setResetSuccess(true)
      })
    },
    goToLogin: ({ actions, setResetSuccess }) => () => {
      actions.redirect('/login')
      setResetSuccess(false) 
    },
  }),
)



// WEBPACK FOOTER //
// ./src/containers/account/ResetPassword/Reset.enhancer.js